// src/slices/apiSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import adminAxiosInstance from "../../../api/adminAxiosInstance";
import { endpoints } from "../../../api/endpoints";

export const AdminReportsApi = createAsyncThunk(
  "Reports/AdminReportsApi",
  async (Data, { rejectWithValue }) => {
    try {
      const response = await adminAxiosInstance.post(endpoints.getlistofreportsforadmin, Data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


export const GetRejectedCandidateReportApi = createAsyncThunk(
  "Reports/AdminReportsApi",
  async (Data, { rejectWithValue }) => {
    try {
      const response = await adminAxiosInstance.post(endpoints.getrejectedcandidatereport, Data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const GetContactUsApi = createAsyncThunk(
  "Reports/AdminReportsApi",
  async (Data, { rejectWithValue }) => {
    try {
      const response = await adminAxiosInstance.post(endpoints.getlistofcontactus , Data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);



export const Getofferextendedlist = createAsyncThunk(
  "Reports/getofferextendedlist",
  async (Data, { rejectWithValue }) => {
    try {
      const response = await adminAxiosInstance.post(endpoints.getofferextendedlist, Data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const OfferRejectedApi = createAsyncThunk(
  "Reports/OfferRejectedApi",
  async (Data, { rejectWithValue }) => {
    try {
      const response = await adminAxiosInstance.post(endpoints.getofferdeclinedreport, Data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const getdeleteduserslistApi = createAsyncThunk( 
  "Reports/getdeleteduserslistApi",
  async (Data, { rejectWithValue }) => {
    try {
      const response = await adminAxiosInstance.post(endpoints.getdeleteduserslist, Data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const getpayoutlistApi = createAsyncThunk( 
  "Reports/getpayoutlistApi",
  async (Data, { rejectWithValue }) => {
    try {
      const response = await adminAxiosInstance.post(endpoints.getpayoutlist, Data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const AdminReportsApiSlice = createSlice({
  name: "AdminReportsApiSlice",
  initialState: {
    data: null,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(AdminReportsApi.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getdeleteduserslistApi.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getpayoutlistApi.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(GetRejectedCandidateReportApi.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(AdminReportsApi.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getdeleteduserslistApi.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getpayoutlistApi.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(GetRejectedCandidateReportApi.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(AdminReportsApi.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(getdeleteduserslistApi.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(getpayoutlistApi.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(GetRejectedCandidateReportApi.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});
export default AdminReportsApiSlice.reducer;
